import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { AddTemplate } from './pages/AddTemplate';
import { DetailTemplate } from './pages/DetailTemplate';
import { Templates } from './pages/Templates';

export const MailingRoutes = () => {
  return (
    <Switch>
      <Route path={ROUTES.MAILING} exact={true} component={Templates} />
      <Route path={ROUTES.MAILING_ADD_TEMPLATE} component={AddTemplate} />
      <Route path={ROUTES.MAILING_DETAIL_TEMPLATE} component={DetailTemplate} />
    </Switch>
  );
}
